import React, { useState } from "react";
import { Blacked, ModalContent, ModalHeader, ModalInput, ModalSubmit, ModalTitle, ModalWrapper } from "../styles";
import { Icon } from "CRM/organism/Main/styles";
import { FaChevronLeft } from "react-icons/fa6";
import { Input, Select, message } from "antd";
import API from "utils/api";
import { useToken } from "app/hooks";
import { useBranchList } from "CRM/hooks/GetBranchList";
import { useTeamList } from "../../hooks/GetTeamList";
import { useIsMobile } from "../IsMobile";

export const TeamEdit = ({ setIsEdit, data, mutate }) => {
	const IsMobile = useIsMobile();
	const { data: token } = useToken();
	const { branchList } = useBranchList();
	const { teamList } = useTeamList();

	const [branchId, setBranchId] = useState(data?.branchId || 1);

	const [name, setName] = useState(data?.name || "");
	const [desc, setDesc] = useState(data?.desc || "");

	const clickSubmit = () => {
		const shouldEdit = window.confirm(`수정하실 내용이 맞습니까? \n 팀: ${name} \n 설명: ${desc}`);
		if (shouldEdit) {
			if (name == "") {
				message.error("팀명은 필수 입력입니다.");
			} else {
				API.put("/team/" + data?.id, token + "", {
					datas: {
						branchId: branchId,
						name: name,
						desc: desc,
					},
				})
					.then((res: any) => {
						if (res.result.success) {
							message.success("수정되었습니다");
							mutate();
							setIsEdit(false);
						}
					})
					.catch((err: any) => {});
			}
		}
	};

	return (
		<>
			<Blacked onClick={() => setIsEdit(false)} />
			<ModalWrapper IsMobile={IsMobile}>
				<ModalHeader>
					<Icon onClick={() => setIsEdit(false)}>
						<FaChevronLeft />
					</Icon>
					<ModalTitle>팀 수정</ModalTitle>
					<ModalSubmit onClick={clickSubmit}>저장</ModalSubmit>
				</ModalHeader>
				<ModalContent>
					<Select value={+branchId} onChange={(e) => setBranchId(e)}>
						<label htmlFor="branch">지사명 *</label>
						{process.env.REACT_APP_API_URL?.includes("ccl") && (
							<option style={{ fontFamily: "Pretendard" }} value={1}>
								본사
							</option>
						)}
						{branchList?.map((it) => (
							<option style={{ fontFamily: "Pretendard" }} value={+it.id}>
								{it.name}
							</option>
						))}
					</Select>
					<ModalInput>
						<label htmlFor="name">팀명 *</label>
						<Input
							id="name"
							type="text"
							value={name}
							onChange={(e) => setName(e.target.value)}
							placeholder="상태를 입력해주세요."
						/>
					</ModalInput>
					<ModalInput>
						<label htmlFor="desc">설명</label>
						<Input
							id="desc"
							type="text"
							value={desc}
							onChange={(e) => setDesc(e.target.value)}
							placeholder="설명을 입력해주세요."
						/>
					</ModalInput>
				</ModalContent>
			</ModalWrapper>
		</>
	);
};

export default React.memo(TeamEdit);
